import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost/bootcamp/foundermind-backend/public',
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
  timeout: 30000,
});

// Attach JWT from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('fm_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Normalize primary key fields — backend uses resource_id (e.g. assessment_id),
// add an `id` alias on every object so frontend can use .id consistently.
const PK_FIELDS = [
  'assessment_id', 'question_id', 'bootcamp_id', 'submission_id',
  'participant_id', 'user_id', 'organization_id', 'link_id', 'run_id',
];

function normalizeIds(obj) {
  if (Array.isArray(obj)) return obj.map(normalizeIds);
  if (obj && typeof obj === 'object') {
    const result = { ...obj };
    for (const key of PK_FIELDS) {
      if (key in result && !('id' in result)) {
        result.id = result[key];
        break;
      }
    }
    for (const k of Object.keys(result)) {
      if (result[k] && typeof result[k] === 'object') {
        result[k] = normalizeIds(result[k]);
      }
    }
    return result;
  }
  return obj;
}

// Handle 401 globally — redirect to login
api.interceptors.response.use(
  (res) => {
    if (res.data && typeof res.data === 'object') {
      res.data = normalizeIds(res.data);
    }
    return res;
  },
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('fm_token');
      localStorage.removeItem('fm_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
